import React from "react";
import { PaEmptyState, PaPageHeader } from "components/platform-admin";
import PlatformAdminLayout from "./PlatformAdminLayout";

const PaAccessDenied = ({
  title,
  subtitle,
  message = "You don't have access to this area",
  description = "Contact a Platform Owner if you need access.",
}) => (
  <PlatformAdminLayout>
    <PaPageHeader title={title} subtitle={subtitle} />
    <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
      <PaEmptyState title="Access restricted" message={message} description={description} />
    </div>
  </PlatformAdminLayout>
);

export default PaAccessDenied;
